module.exports = __webpack_public_path__ + "/media/images/cursor-mousewheel.svg";


//////////////////
// WEBPACK FOOTER
// ./images/cursor-mousewheel.svg
// module id = 44
// module chunks = 0